export default __webpack_public_path__ + "static/media/geography.d3bdd05f.svg";